import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Badge, Icon } from '@openedx/paragon';
import { Settings as IconSettings } from '@openedx/paragon/icons';
import { capitalize } from 'lodash';
import { useIntl } from 'react-intl';

import { NOTIFICATION_MESSAGES, notificationIntlMessages } from '../../constants';

const ProcessingNotification = ({ isShow, title }) => {
  const { formatMessage } = useIntl();

  const getTitle = () => {
    if (title === NOTIFICATION_MESSAGES.saving) {
      return formatMessage(notificationIntlMessages.saving);
    }
    return capitalize(title);
  };

  return (
    <Badge
      className={classNames('processing-notification', {
        'is-show': isShow,
      })}
      variant="secondary"
      aria-hidden={isShow}
    >
      <Icon className="processing-notification-icon" src={IconSettings} />
      <h2 className="processing-notification-title">
        {getTitle()}
      </h2>
    </Badge>
  );
};

ProcessingNotification.propTypes = {
  isShow: PropTypes.bool.isRequired,
  title: PropTypes.oneOf(Object.values(NOTIFICATION_MESSAGES)).isRequired,
};

export default ProcessingNotification;
